export default "__VITE_ASSET__CSNaRd3Q__"